import { Column, Columns, Icon } from '@codeparva/ui-components-library';
import React, { useEffect, useState } from 'react';
import { HeroTypes } from '..';
import { Row } from '../../../../../components/row/Row';
import { useHeroVariant } from '../hooks/variantContext';
import { CTAButtonTypes } from '../../../../../components/ctaButton/CTAButtonTypes';
import { FontAwesomeIcon } from './../../../../../utilities/iconLoader/FontAwesomeIcon';
import { getFormattedHrs } from '../../../../sitewide/components/locationMap/LocationMap';
import { ClickableText } from '../../../../../components/clickableText/ClickableText';
import { ClickableTextTypes } from '../../../../../components/clickableText/ClickableTextTypes';
import { FacilityVariant1 } from './facilityDetailsVariants/FacilityVariant1';
import { FacilityVariant2 } from './facilityDetailsVariants/FacilityVariant2';

export const FacilityDetails = ({
  location,
  facilityAmenities,
}: HeroTypes.IFacilityDetails) => {
  const curVariant = useHeroVariant();
  const { locations } = location;
  const curLocation = locations[0];

  const getAddressDetails = () => {
    if (curLocation.gMapDetails) {
      return {
        googleMapPlaceId: curLocation.googleMapPlaceId,
        gMapDetails: curLocation.gMapDetails,
      };
    }
    return undefined;
  };

  const initialAddressConfig: ClickableTextTypes.IClickableText = {
    text: curLocation.addressText,
    type: 'address',
    addressDetails: getAddressDetails(),
  };
  const [addressDetails, setAddressDetails] = useState<
    ClickableTextTypes.IClickableText
  >(initialAddressConfig);

  useEffect(() => {
    const newAddressDetails = getAddressDetails();
    setAddressDetails({
      ...initialAddressConfig,
      addressDetails: newAddressDetails,
    });
  }, [curLocation?.gMapDetails]);

  const renderDetails = ({
    label,
    content,
    clickableTextConfig,
  }: HeroTypes.TRenderDetails) => {
    const renderContent = () => {
      if (clickableTextConfig) {
        return (
          <div className="mt-2">
            <ClickableText
              className={`has-text-black`}
              {...clickableTextConfig}
            />
          </div>
        );
      } else {
        if (typeof content === 'string') {
          return <p className="pt-2">{content}</p>;
        }
      }
      return <div className={`pt-2 customContent`}>{content}</div>;
    };

    return (
      <div>
        <div className="sectionLabel has-background-primary">
          <p className="has-text-white">{label}</p>
        </div>
        {renderContent()}
      </div>
    );
  };

  const GenericIcon = ({ iconName }: CTAButtonTypes.TGenericIconType) => {
    const IconContextProps = {
      style: {
        size: 20,
      },
    };
    return (
      <Icon color="primary">
        <FontAwesomeIcon
          iconClassName={iconName}
          iconContextProps={IconContextProps}
        />
      </Icon>
    );
  };

  const GenericTextComponent = ({
    text,
    icon,
    type,
  }: HeroTypes.TGenericTextComponent) => (
    <>
      <GenericIcon iconName={icon} />
      <ClickableText
        className="px-2 has-text-weight-bold has-text-black"
        text={text}
        type={type}
      />
    </>
  );

  const formattedHrs = getFormattedHrs(curLocation);

  const OtherVariants = () => {
    return (
      <div className="otherVariants">
        <Row>
          <Columns>
            <Column size={5}>
              <p>Left</p>
            </Column>
            <Column size={7}>
              <p>Right</p>
            </Column>
          </Columns>
        </Row>
      </div>
    );
  };

  const getVariantToRender = () => {
    const variantsMap = {
      'hero-section-1': (
        <FacilityVariant1
          curLocation={curLocation}
          addressDetails={addressDetails}
          renderDetails={renderDetails}
          genericIcon={GenericIcon}
          formattedHrs={formattedHrs}
          GenericTextComponent={GenericTextComponent}
        />
      ),
      'hero-section-2': (
        <FacilityVariant2
          curLocation={curLocation}
          addressDetails={addressDetails}
          renderDetails={renderDetails}
          genericIcon={GenericIcon}
          formattedHrs={formattedHrs}
          facilityAmenities={facilityAmenities}
          GenericTextComponent={GenericTextComponent}
        />
      ),
      'hero-section-3': <OtherVariants />,
      'hero-section-4': <OtherVariants />,
    };
    return variantsMap[curVariant];
  };

  return (
    <div className="facilityDetailscontainer is-cp-w-100">
      {getVariantToRender()}
    </div>
  );
};
